<div class="contact-details-card">
  <div class="card-body">
    <form
      [formGroup]="contactForm"
      (ngSubmit)="onSubmit()"
      class="contact-form"
      novalidate
      
    >
      <div class="form-row">
        <div class="form-group">
          <label for="email">Email<span class="required">*</span></label>
          <input
            type="email"
            id="email"
            formControlName="email"
            placeholder="johndoe@example.com"
            maxlength="254"
          />
          <div
            *ngIf="email?.invalid && (email?.dirty || email?.touched)"
            class="error-message"
          >
            <div *ngIf="email?.errors?.['required']">Email is required.</div>
            <div *ngIf="email?.errors?.['strictEmail']">
              Please enter a valid email address.
            </div>
            <div *ngIf="email?.errors?.['maxlength']">
              Email cannot exceed 254 characters.
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="contact">Phone Number<span class="required">*</span></label>
          <input
            type="tel"
            id="contact"
            formControlName="contact"
            placeholder="(123) 456 7890"
            maxlength="15"
          />
          <div
            *ngIf="phone?.invalid && (phone?.dirty || phone?.touched)"
            class="error-message"
          >
            <div *ngIf="phone?.errors?.['required']">
              Phone number is required.
            </div>
            <div *ngIf="phone?.errors?.['usaPhone']">
              Please enter a valid phone number.
            </div>
            <div *ngIf="phone?.errors?.['maxlength']">
              Phone number cannot exceed 15 characters.
            </div>
          </div>
        </div>
      </div>
      <div class="form-actions" >
        <!-- <button type="button" class="btn btn-secondary btn-large" (click)="onCancel()">
          Cancel
        </button> -->
        <button type="submit" class="btn btn-primary btn-large" [ngClass]="{'disabled': contactForm.invalid || !isFormModified || isSubmitting}" [disabled]="contactForm.invalid || !isFormModified || isSubmitting">
          <span *ngIf="!isSubmitting">Save</span>
          <span *ngIf="isSubmitting" class="saving-content">
            <div class="spinner-small"></div>
            Saving...
          </span>
        </button>
      </div>
    </form>
  </div>
</div>
